import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M14.664 13.332a1.33 1.33 0 1 1-2.08-1.1v-2.8h-3.83v2.81a1.323 1.323 0 0 1 .58 1.09 1.335 1.335 0 1 1-2.67 0 1.312 1.312 0 0 1 .59-1.1v-2.8h-3.84v2.8a1.312 1.312 0 0 1 .59 1.1 1.335 1.335 0 1 1-2.67 0 1.323 1.323 0 0 1 .58-1.09v-3.56a.755.755 0 0 1 .75-.75h4.59v-3.45A1.641 1.641 0 0 1 6.334 3a1.665 1.665 0 1 1 3.33 0 1.65 1.65 0 0 1-.91 1.48v3.45h4.58a.755.755 0 0 1 .75.75v3.55a1.327 1.327 0 0 1 .58 1.102Z';
const draw24px =
  'M22,20a2,2,0,0,1-4,0,2,2,0,0,1,1.25-1.85V13.77h-6.5v4.38a2,2,0,1,1-1.5,0V13.77H4.75v4.38a2,2,0,1,1-1.5,0V13A.75.75,0,0,1,4,12.27h7.25V6.89a2.5,2.5,0,1,1,1.5,0v5.38H20a.76.76,0,0,1,.75.75v5.13A2,2,0,0,1,22,20Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const HierarchyIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'hierarchy'),
) as IconWithRender;

HierarchyIcon.displayName = 'HierarchyIcon';
HierarchyIcon.propTypes = Icon.propTypes;
HierarchyIcon.renderIcon = (props) => <HierarchyIcon {...props} />;
export default HierarchyIcon;
